import React, { useState, useContext, useEffect } from "react";
import { Box, TextField, IconButton, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { HourlyDataContext } from "../../Contexts/HourlyDataContext";
import AddIcon from "@material-ui/icons/Add";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "4fr 4fr 1fr",
    gridGap: theme.spacing(1),
  },
  flexColContainer: {
    display: "flex",
    flexDirection: "column",
  },
  flexColItem: {
    marginBottom: theme.spacing(1),
  },
  flexRowContainer: {
    display: "flex",
  },
  flexRowItem: {
    flexGrow: 1,
    width: "100%",
    // whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

function CreateBranchItem({
  className,
  createItem,
  branchModel,
  ...otherProps
}) {
  const classes = useStyles();
  const defaultForm = {
    values: { assignedBranchId: "", assignedAmount: "" },
    valid: { assignedBranchId: false, assignedAmount: false },
  };
  const [formData, setFormData] = useState(defaultForm);

  const handleChange = (event) => {
    setFormData({
      values: {
        ...formData.values,
        [event.target.name]: event.target.value,
      },
      valid: {
        ...formData.valid,
        [event.target.name]: branchModel[event.target.name].validate(
          event.target.value
        ),
      },
    });
  };

  const handleClick = () => {
    setFormData(defaultForm);
    createItem({
      assignedBranchId: Number(formData.values.assignedBranchId),
      assignedAmount: Number(formData.values.assignedAmount),
      id: 0,
      changedRateId: "",
    });
  };

  return (
    <Box className={clsx(classes.gridContainer, className)} {...otherProps}>
      <TextField
        fullWidth
        onChange={handleChange}
        error={!formData.valid.assignedBranchId}
        label={branchModel.assignedBranchId.displayName}
        value={formData.values.assignedBranchId}
        InputLabelProps={{ shrink: true }}
        {...branchModel.assignedBranchId.textFieldProps}
      />
      <TextField
        fullWidth
        onChange={handleChange}
        error={!formData.valid.assignedAmount}
        label={branchModel.assignedAmount.displayName}
        value={formData.values.assignedAmount}
        InputLabelProps={{ shrink: true }}
        {...branchModel.assignedAmount.textFieldProps}
      />
      <Tooltip title="Add branch">
        <div>
          <IconButton
            onClick={handleClick}
            disabled={Object.values(formData.valid).includes(false)}
          >
            <AddIcon />
          </IconButton>
        </div>
      </Tooltip>
    </Box>
  );
}

export default CreateBranchItem;
